import { ComputeFieldComponent } from "../computeFields";
import { Auction } from "../types";
import { SeparatedList } from "./shared/utils";

export const AuctionSummaryCF: ComputeFieldComponent<
  Pick<
    Auction,
    | "ventesDescriptionInclureTitreDansResume"
    | "ventesDescriptionTitre"
    | "ventesDescriptionDate"
    | "ventesDescriptionCommissaires"
    | "ventesDescriptionLieu"
    | "ventesDescriptionVille"
    | "ventesDescriptionPays"
  >
> = ({ input, lineBreak = false, ...props }) => {
  const resumeItems = [
    input.ventesDescriptionInclureTitreDansResume
      ? input.ventesDescriptionTitre
      : null,
    input.ventesDescriptionDate,
    input.ventesDescriptionCommissaires,
    input.ventesDescriptionLieu,
    input.ventesDescriptionVille,
    input.ventesDescriptionPays,
  ].filter((item) => !!item);
  return <SeparatedList input={resumeItems} lineBreak={lineBreak} {...props} />;
};
